var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"no-data-item"},[_c('div',{staticClass:"no-data-text",staticStyle:{"color":"#2F6BCF"}},[_vm._v(_vm._s(_vm.titles))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }